'use strict';
import $ from 'jquery';
import { gsap } from 'gsap';

$(document).ready(function () {
    if (window.location.pathname === '/') {
        let listOfItems = ['.hero__logo', '.hero__label', '.hero__title', '.hero__text', '.hero__btn-holder'];

        for (let i = 0; i < listOfItems.length; i++) {
            gsap.from($(listOfItems[i]), {
                autoAlpha: 0,
                y: 25,
                duration: 0.5 / ((i + 1) / 6),
                ease: 'power3',
                stagger: 0.25 + ((i + 1) / 3),
                delay: (i + 1) * 0.3
            });
        }
    }

    if (window.location.pathname.includes('/challenge')) {
        window.history.back();
    }
});
